export const resources = {
  es: {
    translation: {
      English: 'Español',
      Learn: 'Aprender',
      Case: 'Caso',
      Results: 'Resultados',
      'General Reference': 'Referencia general',
      'Unit Processes': 'Procesos unitarios',
      'Treatment Trains': 'Trenes de tratamiento',
      'Case Studies': 'Estudios de caso',
      'Water Qualities': 'Cualidades del agua',
      Name: 'Nombre',
      'Average Pollutant Removal Efficiencies [% removal]':
        'Eficiencias medias de eliminación de los contaminates [% de eliminación]',
      Turbidity: 'Turbidez',
      Recovery: 'Recuperación',
      'Evaluation Criteria': 'Criterios de evaluación',
      'Useful Life [yrs]': 'Vida útil [años]',
      Search: 'Buscar en',
      'Download CSV': 'Descargar CSV',
      'View Columns': 'Ver columnas',
      'Filter Table': 'Tabla de filtros',
      'Rows per page': 'Filas por páginas',
      Category: 'Categoría',
      Title: 'Título',
      Description: 'Descripción',
      'Case Study': 'Estudio de caso',
      Note: 'Nota',
      Reference: 'Referencia',
      Tags: 'Etiquetas',
      Type: 'Tipo',
      Presets: 'Preestablecidos',
      Custom: 'Personalizados',
      'Community Information': 'Información Comunitaria',
      Input: 'Introducir',
      'End Use': 'Uso Final',
      'end use': 'uso final',
      'End use, needs treatment': 'Uso Final, necesita tratamiento',
      'End use, no treatment needed': 'Uso Final, no necesita tratamiento',
      Quantity: 'Cantidad',
      Personalize: 'Personalizar',
      'See Results': 'Ver Resultados',
      Next: 'Siguiente',
      Back: 'Volver',
      'Case Overview': 'Resumen del Caso',
      'Select the Country': 'Seleccionar país',
      'Select the Currency': 'Seleccionar moneda',
      'Land Cost per Hectare': 'Costo de la tierra por hectárea',
      'Electricity Cost per kWh': 'Costo de electricidad por kWh',
      'Average Staff Cost per Hour': 'Costo promedio de personal por hora',
      'Discount Rate per Annum': 'Tasa de descuento anual',
      Country: 'País',
      Currency: 'Moneda',
      'Select the Category': 'Seleccione una categoría',
      'Water Quality Class': 'Categoría de calidad de agua',
      'Average Quantity': 'Cantidad promedio',
      day: 'día',
      'Water Quality Indicators': 'Indicadores de calidad del agua',
      'Expected between 1 and': 'Se espera entre 1 y',
      input: 'entrada',
      output: 'salida',
      'typ. ww.': 'res. típ.',
      'Input into Treatment Train': 'Entrada en el tren de tratamiento',
      'Typical untreated domestic wastewater': 'Aguas residuales domésticas típicas sin tratar',
      'Personalize Solutions': 'Personalizar soluciones',
      'Based on your input, no treatment is needed because the input quality is better than the end use quality.':
        'Según su aportación, no es necesario ningún tratamiento porque la calidad de la aportación es mejor que la del uso final.',
      'Based on your input, theres no possible solution': 'Según su aportación, no hay solución posible',
      'Based on your input, the following treatment trains are best suited for the case.':
        'Según sus aportaciónes, los siguientes trenes de tratamiento son los más adecuados para el caso.',
      'The solution cannot be calculated because there is no input for a defined end use.':
        'No se puede calcular la solución porque no hay ninguna entrada para un uso final definido.',
      Rating: 'Clasificación',
      'Treatment Train': 'Trene de tratamiento',
      Cost: 'Coste',
      'Rating [0-3]': 'Clasificación [0-3]',
      'This Poseidon – Web on-line application is an update of the already existing developed Poseidon application based on Microsoft Excel. The scope of the new application is to enhance the older version to a more user-friendly decision support tool, that supports pre-feasibility studies and aims at promoting water reuse and building capacities in the field. The tool developed currently encompasses >40-unit processes combined into >60 benchmark treatment trains. It also contains information on water quality standards and typical wastewater qualities. It estimates the removal performances for key parameters and the lifecycle costs of the additional treatment train.':
        'Esta aplicación web Poseidon es una actualización de la aplicación Poseidon, ya desarrollada y basada en Microsoft Excel. El objetivo de la nueva aplicación es mejorar la versión anterior y convertirla en una herramienta de apoyo a la toma de decisiones más intuitiva, que facilita los estudios de prefactibilidad y busca promover la reutilización del agua y el desarrollo de capacidades sobre el terreno. La herramienta desarrollada actualmente abarca más de 40 procesos unitarios combinados en más de 60 trenes de tratamiento de referencia. También contiene información sobre los estándares de calidad del agua y las características típicas de las aguas residuales. Estima el rendimiento de eliminación de parámetros clave y los costos del ciclo de vida del tren de tratamiento adicional.',
      'The tool and all underlying data are open access and under continuous development. The underlying systemic approach of the tool makes it intuitive also for users with limited prior knowledge in the field to identify most adequate solutions based on a multi-criteria assessment. This should help to promote water reuse and spearhead initiates for more detailed feasibility and design commissioning for implementation of water reuse schemes.':
        'La herramienta y todos los datos subyacentes son de libre acceso y están en continuo desarrollo. El enfoque sistémico subyacente de la herramienta hace que sea intuitivo también para los usuarios con conocimientos previos limitados en el campo para identificar las soluciones más adecuadas basadas en una evaluación multicriterio. Esto debería ayudar a promover la reutilización del agua y a iniciar una viabilidad más detallada y un encargo de diseño para la aplicación de los planes de reutilización del agua.',
      'The figure on the right shows a simplified flow of how the application works and how the calculations are being made.':
        'La figura de la derecha muestra un flujo simplificado de cómo funciona la aplicación y cómo se realizan los cálculos.',
      'Overview of application and calculations': 'Resumen de la aplicación y los cálculos',
      Ranking: 'Clasificación',
      'Annualized CAPEX': 'CAPEX anualizado',
      'Annualized Land Cost': 'Coste anualizado del terreno',
      'Annualized Energy Cost': 'Coste energético anualizado',
      'Annualized Labor Cost': 'Coste laboral anualizado',
      'Annualized Other O&M Cost': 'Otros costos de operación y mantenimiento anualizados',
      'Energy Requirements': 'Requerimientos de energía',
      'Labor Requirements': 'Requisitos laborales',
      'Annualized OPEX': 'OPEX anualizado',
      'Annualized Total Cost': 'Coste total anualizado',
      'Land Requirements': 'Requerimientos de tierra',
      'Cost per m3': 'Costo por m3',
      'Total capital expenditure (CAPEX)': 'Total de gastos de capital (CAPEX)',
      'Treatment Cost': 'Coste del tratamiento',
      'Sort by rating': 'Ordenar por clasificación',
      'p-h/mo': 'p-h/mes',
      'kWh/y': 'kWh/año',
      'Output Values': 'Valores de salida',
      'Sorry, no matching records found': 'Lo sentimos, no se han encontrado registros coincidentes',
      Sort: 'Ordenar',
      'Outflow Values / Limit Values': 'Valores de salida / Valores límite',
      Wastewater: 'Aguas residuales',
      'Quality Standard': 'Norma de calidad',
      Solutions: 'Soluciones',
      Factor: 'Factora',
      'Min. Requirements Met': 'Requisitos mínimos cumplidos',
      'Output Value': 'Valor de salida',
      'Cost per Cubic': 'Costo por metro cúbico',
      'Regression Coefficients': 'Coeficientes de regresión',
    },
  },
  ja: {
    translation: {
      English: '日本語',
      Learn: '学ぶ',
      Case: '場合',
      Results: '結果',
      'General Reference': '一般的な参照',
      'Unit Processes': 'ユニットプロセス',
      'Treatment Trains': '治療列車',
      'Case Studies': 'ケーススタディ',
      'Water Qualities': '水質',
      Name: '名前',
      'Average Pollutant Removal Efficiencies [% removal]': '平均汚染物質除去効率[％除去]',
      Turbidity: '濁度',
      Recovery: '回復',
      'Evaluation Criteria': '評価基準',
      'Useful Life [yrs]': '耐用年数[年]',
      Search: '検索',
      'Download CSV': 'CSVをダウンロードします',
      'View Columns': '列を表示します',
      'Filter Table': 'フィルターテーブル',
      'Rows per page': '1ページあたりの行',
      Category: 'カテゴリ',
      Title: 'タイトル',
      Description: '説明',
      'Case Study': 'ケーススタディ',
      Note: '注記',
      Reference: '参照',
      Tags: 'タグ',
      Type: 'タイプ',
      Presets: 'プリセット',
      Custom: 'カスタム',
      'Community Information': 'コミュニティ情報',
      Input: '入力',
      'End Use': '使用を終了します',
      'end use': '使用を終了します',
      'End use, needs treatment': '使用を終了し、治療が必要です',
      'End use, no treatment needed': '使用を終了し、治療は必要ありません',
      Quantity: '量',
      Personalize: 'パーソナライズ',
      'See Results': '結果を参照してください',
      Next: '次',
      Back: '戻る',
      'Case Overview': 'ケースの概要',
      'Select the Country': '国を選択します',
      'Select the Currency': '通貨を選択します',
      'Land Cost per Hectare': '1ヘクタールあたりの土地コスト',
      'Electricity Cost per kWh': '1kWhあたりの電気料金',
      'Average Staff Cost per Hour': '1時間あたりの平均スタッフコスト',
      'Discount Rate per Annum': '年間割引率',
      Country: '国',
      Currency: '通貨',
      'Select the Category': 'カテゴリを選択します',
      'Water Quality Class': '水質クラス',
      'Average Quantity': '平均量',
      day: '日',
      'Water Quality Indicators': '水質指標',
      'Expected between 1 and': '1と間に予想されます',
      input: '入力',
      output: '出力',
      'typ. ww.': 'タイプ。',
      'Input into Treatment Train': '治療列車への入力',
      'Typical untreated domestic wastewater': '典型的な未処理の国内廃水',
      'Personalize Solutions': 'ソリューションをパーソナライズします',
      'Based on your input, no treatment is needed because the input quality is better than the end use quality.':
        '入力に基づいて、入力品質が最終使用品質よりも優れているため、治療は必要ありません。',
      'Based on your input, theres no possible solution': '入力に基づいて、解決策はありません。',
      'Based on your input, the following treatment trains are best suited for the case.':
        '入力に基づいて、次の治療列車がケースに最適です。',
      'The solution cannot be calculated because there is no input for a defined end use.':
        '定義された最終用途の入力がないため、ソリューションを計算できません。',
      Rating: '評価',
      'Treatment Train': '治療列車',
      Cost: '料金',
      'Rating [0-3]': '評価[0-3]',
      'This Poseidon – Web on-line application is an update of the already existing developed Poseidon application based on Microsoft Excel. The scope of the new application is to enhance the older version to a more user-friendly decision support tool, that supports pre-feasibility studies and aims at promoting water reuse and building capacities in the field. The tool developed currently encompasses >40-unit processes combined into >60 benchmark treatment trains. It also contains information on water quality standards and typical wastewater qualities. It estimates the removal performances for key parameters and the lifecycle costs of the additional treatment train.':
        'この Poseidon – Web オンライン アプリケーションは、Microsoft Excel をベースに既に開発されている Poseidon アプリケーションの更新版です。新しいアプリケーションの目的は、旧バージョンを、事前実行可能性調査をサポートし、水の再利用を促進し、現場での能力構築を目指す、よりユーザー フレンドリな意思決定支援ツールに拡張することです。開発されたツールは現在、60 を超えるベンチマーク処理トレインに統合された 40 を超えるユニット プロセスを網羅しています。また、水質基準と一般的な廃水品質に関する情報も含まれています。主要なパラメータの除去性能と、追加の処理トレインのライフサイクル コストを推定します。',
      'The tool and all underlying data are open access and under continuous development. The underlying systemic approach of the tool makes it intuitive also for users with limited prior knowledge in the field to identify most adequate solutions based on a multi-criteria assessment. This should help to promote water reuse and spearhead initiates for more detailed feasibility and design commissioning for implementation of water reuse schemes.':
        'ツールとすべての基礎となるデータは、オープンアクセスであり、継続的な開発中です。 ツールの基礎となる体系的なアプローチにより、フィールドでの予備知識が限られているユーザーにとっても直感的になり、マルチ基準評価に基づいて最も適切なソリューションを特定します。 これは、水の再利用と先頭の開始を促進するのに役立ちます。',
      'The figure on the right shows a simplified flow of how the application works and how the calculations are being made.':
        '右側の図は、アプリケーションの仕組みと計算がどのように行われているかの単純化されたフローを示しています。',
      'Overview of application and calculations': 'アプリケーションと計算の概要',
      Ranking: 'ランキング',
      'Annualized CAPEX': '年間の設備',
      'Annualized Land Cost': '年間の土地費用',
      'Annualized Energy Cost': '年間エネルギーコスト',
      'Annualized Labor Cost': '年間人件費',
      'Annualized Other O&M Cost': 'その他の年間運営費および保守費',
      'Energy Requirements': 'エネルギー要件',
      'Labor Requirements': '労働要件',
      'Annualized OPEX': '運用コスト年率',
      'Annualized Total Cost': '年間総費用',
      'Land Requirements': '土地の要件',
      'Cost per m3': 'm3あたりのコスト',
      'Total capital expenditure (CAPEX)': '総資本支出（設備投資）',
      'Treatment Cost': '治療費',
      'Sort by rating': '評価でソートします',
      'p-h/mo': '人時/月',
      'kWh/y': 'kWh/年',
      'Output Values': '出力値',
      'Sorry, no matching records found': '申し訳ありませんが、一致するレコードは見つかりませんでした',
      Sort: '選別',
      'Outflow Values / Limit Values': '流出値 / 制限値',
      Wastewater: '廃水',
      'Quality Standard': '品質基準',
      Solutions: 'ソリューション',
      Factor: '要素',
      'Min. Requirements Met': '最小要件を満たしています',
      'Output Value': '出力値',
      'Cost per Cubic': '立方メートルあたりのコスト',
      'Regression Coefficients': '回帰係数',
    },
  },
}
